import { render } from "./Liquidation.vue?vue&type=template&id=53a5acaa"
import script from "./Liquidation.vue?vue&type=script&lang=js"
export * from "./Liquidation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__